import { render } from "./baseLayout.vue?vue&type=template&id=315d3c25&scoped=true&ts=true"
import script from "./baseLayout.vue?vue&type=script&lang=ts"
export * from "./baseLayout.vue?vue&type=script&lang=ts"

import "./baseLayout.vue?vue&type=style&index=0&id=315d3c25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315d3c25"]])

export default __exports__